// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_78-0";